import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Image, Label, Form, Table, Transition } from 'semantic-ui-react';
import { userActions } from '../actions';
import Strings from './../common/Strings';
import './Login.css';

const PHASE_LOGIN = 'login';
const PHASE_SIGN_UP = 'signup';

class Login extends React.Component {
  constructor(props) {
    super(props);

    let phase = PHASE_LOGIN;
    const { location } = props;
    if (location && location.pathname === '/signup') {
      phase = PHASE_SIGN_UP;
    }

    this.state = {
      phase,
      email: '',
      password: '',
    };
  }

  getButtonText() {
    return this.state.phase === PHASE_LOGIN
      ? Strings.LOGIN.logIn
      : Strings.LOGIN.signUp;
  }

  forgotPassword = () => {
    const { email } = this.state;
    const { dispatch } = this.props;

    dispatch(userActions.forgotPassword(email));
  };

  submit = e => {
    e.preventDefault();

    const { email, password } = this.state;
    const { dispatch } = this.props;

    if (this.state.phase === PHASE_LOGIN) {
      dispatch(userActions.login(email, password));
    } else {
      dispatch(userActions.signUp(email, password));
    }
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  renderSwitch() {
    return (
      <div className="login-form-switch">
        <div
          id="login-form-switch-login"
          className={this.state.phase === PHASE_LOGIN ? 'selected' : ''}
          onClick={() => this.setState({ phase: PHASE_LOGIN })}
        >
          <p
            className={this.state.phase === PHASE_LOGIN ? 'text-selected' : ''}
          >
            {Strings.LOGIN.logIn}
          </p>
        </div>
        <div
          id="login-form-switch-signup"
          className={this.state.phase === PHASE_SIGN_UP ? 'selected' : ''}
          onClick={() => this.setState({ phase: PHASE_SIGN_UP })}
        >
          <p
            className={
              this.state.phase === PHASE_SIGN_UP ? 'text-selected' : ''
            }
          >
            {Strings.LOGIN.signUp}
          </p>
        </div>
      </div>
    );
  }

  renderError() {
    const visible = this.props.userError.length > 0;
    return (
      <Transition visible={visible} animation="fade" duration={500}>
        <Label id="error-text" className="error">
          {this.props.userError}
        </Label>
      </Transition>
    );
  }

  renderFooter() {
    if (this.state.phase === PHASE_LOGIN) {
      return (
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell
                id="forgot-pw-link"
                className="link-text"
                onClick={this.forgotPassword}
              >
                {Strings.LOGIN.forgotPassword}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return (
      <Table>
        <Table.Body>
          <Table.Row>
            <p id="terms-text" className="terms">
              {Strings.LOGIN.bySigningUp1}
              <a
                id="terms-link"
                className="link-text"
                target="_blank"
                rel="noopener noreferrer"
                href="https://iworkie.com/terms-of-service"
              >
                {Strings.LOGIN.terms}
              </a>
              {Strings.LOGIN.bySigningUp2}
              <a
                id="privacy-link"
                className="link-text"
                target="_blank"
                rel="noopener noreferrer"
                href="https://iworkie.com/privacy-policy"
              >
                {Strings.LOGIN.privacy}
              </a>
            </p>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const { email, password } = this.state;
    return (
      <div className="login">
        <div className="login-form">
          <Image id="app-logo" className="top-img" src="/logo-manager.png" />
          <Form onSubmit={this.submit} loading={this.props.isUserLoading}>
            {this.renderSwitch()}
            {this.renderError()}
            <Form.Input
              id="email-input"
              placeholder={Strings.LOGIN.emailHint}
              name="email"
              value={email}
              onChange={this.handleChange}
            />
            <Form.Input
              id="password-input"
              placeholder={Strings.LOGIN.passwordHint}
              name="password"
              value={password}
              type="password"
              onChange={this.handleChange}
            />
            <Form.Button
              id="submit-button"
              className="button-green"
              content={this.getButtonText()}
              primary
            />
            {this.renderFooter()}
          </Form>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isUserLoading: PropTypes.bool,
  userError: PropTypes.string,
  location: PropTypes.shape,
};

Login.defaultProps = {
  isUserLoading: false,
  userError: '',
  location: undefined,
};

const mapStateToProps = state => ({
  isUserLoading: state.uiState.isUserLoading,
  userError: state.uiState.userError,
});

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js